import React, { useState , useEffect, useRef} from "react";
import "./TermsAndConditions.css";
import Markdown from "react-markdown";
import { Checkbox, Modal, Button, IconButton } from "@mui/material";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { useGetDocumentsSignUpQuery } from "../../services/documentsApi";
import CircularProgress from "@mui/material/CircularProgress";
import rehypeRaw from 'rehype-raw';

import { marked } from "marked";
import html2pdf from "html2pdf.js";

const TermsAndConditionsSignup = ({ open, handleClose, onDocumentAccept }) => {
  
  const { data: documents, isFetching: fetching } = useGetDocumentsSignUpQuery();

  const [documentIndex, setDocumentIndex] = useState(0);
  const [readConfirmation, setReadConfirmation] = useState({});
  const [acceptConfirmation, setAcceptConfirmation] = useState({});
  const [acceptedDocuments, setAcceptedDocuments] = useState([]);
  const [documentFirstViewed, setDocumentFirstViewed] = useState({});

  const newBee = 4;
  const document = documents?.filter(doc => {
    return doc.documentType.userTypeID === newBee && doc.version === doc.documentType.currentVersion;
  });

  document?.sort((a, b) => a.documentTypeID - b.documentTypeID);

  console.log("DEBUG: document", document);

  useEffect(() => {
    if (document && document.length > 0) {
      const currentDocumentId = document[documentIndex]?.id;
      if (currentDocumentId && !documentFirstViewed[currentDocumentId]) {
        const currentTimestamp = new Date().toISOString().slice(0, 19).replace('T', ' ');
        setDocumentFirstViewed(prevState => ({
          ...prevState,
          [currentDocumentId]: currentTimestamp
        }));
      }
    }
  }, [document, documentIndex]);

  const handleAccept = async () => {

    if (documentIndex < document.length - 1) {
      setDocumentIndex(documentIndex + 1);
    }

    setAcceptConfirmation((prevAcceptConfirmation) => {

      const updatedAcceptConfirmation = { ...prevAcceptConfirmation, [documentIndex]: true };

      if (
        Object.keys(readConfirmation).length === document.length &&
        Object.values(readConfirmation).every((v) => v) &&
        Object.keys(updatedAcceptConfirmation).length === document.length &&
        Object.values(updatedAcceptConfirmation).every((v) => v)
      ) {
        const acceptedIDs = document.map(doc => ({
          documentTypeID: doc.id,
          firstViewedOn: documentFirstViewed[doc.id]
        }));
        setAcceptedDocuments(acceptedIDs.map(item => item.documentTypeID));
        onDocumentAccept(acceptedIDs);
        handleClose();
      }

      return updatedAcceptConfirmation;

    });
    
  }

  const onClose = () => {
    setDocumentIndex(0);
    setReadConfirmation({});
    setAcceptConfirmation({});
    setAcceptedDocuments([]);
    handleClose();
  };

  function ActiontButtons () {

    const handleDownload = () => {
      if (document) {
        const htmlContent = marked.parse(document[documentIndex]?.documentContent);
        const element = window.document.createElement("div");
        element.innerHTML = htmlContent;
        element.className = "pdf-content";
        element.style.padding = "20mm 15mm";

        const options = {
          filename: 'EncoreHive-TermsAndConditions.pdf',
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: 'avoid-all' }
        };
        html2pdf().from(element).set(options).save();
      }
    };

    const handlePrint = () => {
      if (document) {
        const htmlContent = marked.parse(document[documentIndex]?.documentContent);
        const printFrame = window.document.createElement('iframe');
        printFrame.setAttribute('allow-modals', 'true');
        printFrame.style.visibility = 'hidden';
        window.document.body.appendChild(printFrame);
        printFrame.contentDocument.open();
        printFrame.contentDocument.write(htmlContent);
        printFrame.contentDocument.close();
        printFrame.contentWindow.focus();
        printFrame.contentWindow.print();
        window.document.body.removeChild(printFrame);
      }
    }

    return (

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "100%", width: "content-fit" }}>
        
        <IconButton 
          sx={{ 
            color: "white", 
            borderRadius: "50%", 
            margin: "0 0.5em 0 0", 
            height: "1.6em", 
            width: "1.6em" 
          }}
          onClick={handleDownload}>
          <FileDownloadOutlinedIcon 
            sx={{ 
              backgroundColor: "var(--orange)",
              borderRadius: "50%", 
              height: "1.6em", 
              width: "1.6em", 
              padding: "0.2em" 
            }} 
          />
        </IconButton>

        <IconButton 
          sx={{ 
            color: "white", 
            borderRadius: "50%", 
            margin: "0 0.5em 0 0", 
            height: "1.6em", 
            width: "1.6em" 
          }}
          onClick={handlePrint}>
          <LocalPrintshopOutlinedIcon 
            sx={{ 
              backgroundColor: "var(--orange)",
              borderRadius: "50%", 
              height: "1.6em", 
              width: "1.6em", 
              padding: "0.2em" }} 
          />
        </IconButton>

        <Button onClick={onClose} variant="outlined" className="button">Close</Button>
      
      </div>
    
  )
  
}

  function CircularProgressComp() {
    return (
      <CircularProgress sx={{ 
        color: "#F29B1B", 
        position: "absolute", 
        top: "50%", 
        left: "50%" 
      }} />
    )
  }

  function NoDocumentsToShow() {
    return (
      <>
        <p>There is no document to show</p>
        <ActiontButtons></ActiontButtons>
      </>
    )
  }

  const divRef = useRef(null);

  useEffect(() => {
    divRef.current && (divRef.current.scrollTop = 1)
  }, [documentIndex]);

  return (

    <Modal open={open} onClose={onClose} className="terms-and-conditions-modal">

      <div className="terms-and-conditions">

        <div style={{ textAlign:'center', width: '100%', marginBottom: '1em' }}>

          <p className="terms-and-conditions-title">
            {document?.[documentIndex]?.documentType?.name}
          </p>
          
        </div>

        <div ref={divRef} className="terms-and-conditions-content">

          {!fetching && !document && <NoDocumentsToShow />}

          {
            fetching ? 
              <CircularProgressComp/>
            :
            (
              <>
                  
                <Markdown rehypePlugins={[rehypeRaw]} children={document?.[documentIndex]?.documentContent} />

                <div className="terms-and-conditions-user-input">
                  <div className="terms-and-conditions-check">
                    <Checkbox 
                      checked={readConfirmation[documentIndex] || false}
                      onChange={(e) => { setReadConfirmation({ ...readConfirmation, [documentIndex]: e.target.checked }); }}
                    />
                    <label>
                      I have read, understood, and accept the terms and information presented here.
                    </label>
                  </div>
                  <Button 
                    disabled={!readConfirmation[documentIndex] || fetching}
                    variant="contained" 
                    className="button" 
                    onClick={handleAccept}
                  >
                    Accept
                  </Button>
                </div>
              </>
            )
          }
         
        </div>
        
        <div className="terms-and-conditions-user-input">
          <ActiontButtons></ActiontButtons>
        </div>

      </div>

    </Modal>
    
  );

};

export default TermsAndConditionsSignup;
